import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class MovimientoService {

  url = environment.baseUrl+ '/api/movimiento';


  constructor(private http: HttpClient) {}

  getMovimientos(obj:any): Observable<any> {
    return this.http.post<any>(this.url + '/GetMovimientos', obj, httpOption);
  }
  getMovimientosAdmin(obj:any): Observable<any> {
    return this.http.post<any>(this.url + '/GetMovimientosAdmin', obj, httpOption);
  }
}
